const state = {
    shopping_list: [],
    checked_items: [],
    categories: []
}

const mutations = {
    SET_LIST (state, value) {
        state.shopping_list = value
    },
    SET_CATEGORIES (state, value) {
        let categories = [{text: 'None', value: 0}]
        value.forEach(category => {
            categories.push({text: category.title, value: category.id})
        })
        state.categories = categories
    }
}

const actions = {
    setShoppingList ({commit}, value) {
        commit('SET_LIST', value)
    },
    loadShoppingList ({state, rootState, dispatch, commit}, route) {
        let routes = route.split('/')
        let data = {stream: rootState.Streams.stream.id}
        let id = routes[3]
        switch (routes[1]) {
            case 'recipe':
                data.recipe_id = id
                break
            case 'meal':
                data.meal_id = id
                break
            case 'meal-plan':
                data.challenge_id = id
                data.week = rootState.MealPlan.current_week
                break
        }

        axios.post(rootState.Settings.apiUrl + '/load-shoppinglist', data)
            .then(function (response) {
                dispatch('ShoppingList/setShoppingList', response.data.items, {root: true})
                commit('SET_CATEGORIES', response.data.categories)
            })
    },
    multiplyShoppingList ({state, rootState, dispatch}) {
        var shoppingList = state.shopping_list

        for (const [key, value] of Object.entries(shoppingList)) {
            for (const [key, item] of Object.entries(value.items)) {
                item.multi_unit = item.unit * rootState.Settings.multiply
                item.multi_percent = item.percent * rootState.Settings.multiply
            }
        }
        dispatch('setShoppingList', shoppingList)

    },
    updateShoppingList ({rootState, dispatch}, data) {
        axios.post(rootState.Settings.apiUrl + '/update-shoppinglist', data.item)
            .then(function (response) {
                dispatch('loadShoppingList', data.route)
            })
    }
}

const getters = {
    shopping_list: state => {
        return state.shopping_list
    },
    categories: state => {
        return state.categories
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
